import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const SelectedLink = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.BR300};
  cursor: pointer;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: end;
    font-size: 16px;
    margin-top: 12px;
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const SelectedUrl = styled.div`
  color: ${({ theme }) => theme.palette.BR300};
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;
export const FilterTbWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Label = styled.h3`
  font-weight: 700;
  font-size: 22px;
  line-height: 31px;
  color: ${({ theme }) => theme.palette.coral};
  margin-bottom: 20px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    font-weight: 900;
    font-size: 30px;
    line-height: 38px;
  }
`;

export const ItemWrapper = styled.div<{ index?: number }>`
  display: grid;
  grid-gap: 13px;
  grid-template-columns: repeat(4, 300px);
  grid-template-rows: repeat(2, 235px);
  max-width: 1240px;
  grid-auto-flow: column;
`;
export const Content = styled.div``;

export const ItemWrapperMobile = styled.div`
  max-width: 100vw;

  div.swiper-slide {
    height: 200px;
    width: 310px !important;
  }
`;
